import { apiRequest } from "./apiRequest";
import { appSession, clearCmdraft, clearUser, KEYS } from "./storage";
import { showToast } from "./toastOptions";
import { clearUserSessionCache } from "./useUserSession";

let cachedAuthStatus = null;
let authCheckPromise = null;

export function getCachedAuthStatus() {
  return cachedAuthStatus;
}

export function checkAuthOnce() {
  if (cachedAuthStatus !== null) return Promise.resolve(cachedAuthStatus);
  if (!authCheckPromise) {
    authCheckPromise = apiRequest(`${process.env.REACT_APP_API_BASE_URL}/validate-token/`, {
      method: "GET",
      suppressErrorToast: true,
      redirectOn401: false,
    })
      .then((data) => {
        cachedAuthStatus = !!data?.authenticated;
        return cachedAuthStatus;
      })
      .catch(() => {
        cachedAuthStatus = false;
        return false;
      });
  }
  return authCheckPromise;
}

export function clearAuthCache() {
  cachedAuthStatus = null;
  authCheckPromise = null;
}

export const loginUser = () => {
  window.location.href = `${process.env.REACT_APP_API_BASE_URL}/login/`;
};

export const logoutUser = async (navigate) => {
  try {
    await apiRequest(`${process.env.REACT_APP_API_BASE_URL}/logout/`, {
      method: "POST",
      suppressErrorToast: true,
      redirectOn401: false,
    });
  } catch (e) {
    // Logout call failed but continue with local cleanup
    // No need to show error to user as we're logging out anyway
    showToast("error", "Logout request failed, but continuing with local cleanup");
  }

  // Clear client-side UI/cache only (no tokens are stored anymore)
  appSession.remove(KEYS.companiesData);
  clearUser();
  clearCmdraft();
  clearAuthCache();
  clearUserSessionCache();

  // Force navigation to login page
  window.location.href = "/login";
};

export const handleAuthCallback = async (navigate) => {
  try {
    const resp = await apiRequest(`${process.env.REACT_APP_API_BASE_URL}/validate-token/`, {
      method: "GET",
      suppressErrorToast: true,
      redirectOn401: false,
    });

    if (resp?.authenticated) {
      navigate("/home");
    } else {
      navigate("/login");
    }
  } catch (err) {
    // Network or other error - redirect to login
    showToast("error", err.message || "Authentication validation failed");
    navigate("/login");
  }
};

export const getHeaders = (forceRefresh = false) => {
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };
  const csrfToken = getCookie("csrftoken");
  if (csrfToken) headers["X-CSRFToken"] = csrfToken;
  if (forceRefresh) headers["Cache-Control"] = "no-cache";
  return headers;
};

export const getCookie = (name) => {
  let cookieValue = null;
  if (document.cookie && document.cookie !== "") {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === name + "=") {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
};
